import { getBearerToken } from './cookieUtils'

/**
 * Wraps the native fetch with the credentials needed to authenticate against
 * the auth service directly (outside the same-origin interceptor's scope).
 *
 * Sends `credentials: 'include'` so the HttpOnly `mb3_access_token` cookie on
 * the parent `.materialbank.com` domain is auto-attached for cross-origin
 * calls to `*.materialbank.com` in production. Attaches an `Authorization:
 * Bearer` header using the cookie-first / bearer-fallback precedence from
 * `getBearerToken` (see cookieUtils).
 *
 * If no token is present the request is sent without an Authorization header
 * so the upstream service can return a proper 401.
 */
export async function authenticatedFetch(
  url: string,
  init?: RequestInit,
): Promise<Response> {
  const token = getBearerToken()

  const headers = new Headers(init?.headers)
  if (token) {
    headers.set('Authorization', `Bearer ${token}`)
  }

  return fetch(url, {
    ...init,
    headers,
    credentials: 'include',
  })
}
